import type { StandardApplicability } from '@/shared/hooks/api/machineryDirectiveCompliance'
import { OnboardingCStandardsReviewTable } from './OnboardingCStandardsReviewTable'

type OnboardingCStandardsReviewStepProps = {
  complianceId: string
  standards: StandardApplicability[]
  selectedIds: Set<string>
  onSelectedIdsChange: (
    next:
      | Set<string>
      | ((previous: Set<string>) => Set<string>)
  ) => void
  onComplete: () => void
  onRerunTypeCStandardCheck: () => void
  isTypeCStandardCheckRunning: boolean
}

export function OnboardingCStandardsReviewStep({
  complianceId,
  standards,
  selectedIds,
  onSelectedIdsChange,
  onComplete,
  onRerunTypeCStandardCheck,
  isTypeCStandardCheckRunning,
}: OnboardingCStandardsReviewStepProps) {
  return (
    <OnboardingCStandardsReviewTable
      standards={standards}
      complianceId={complianceId}
      selectedIds={selectedIds}
      onSelectedIdsChange={onSelectedIdsChange}
      onComplete={onComplete}
      onRerunTypeCStandardCheck={onRerunTypeCStandardCheck}
      isTypeCStandardCheckRunning={isTypeCStandardCheckRunning}
    />
  )
}
